<!--
  La colonne « APV − sorti − stock » du mail (gapCell, demandée par Clément le
  2026-10-09) : acheté sur l'APV, moins ce qui est sorti sur les avize XYLO,
  moins ce que SUMAL déclare encore au dépôt. Les trois termes s'écrivent
  dessous pour que le chiffre se vérifie de tête. Rouge au-delà de
  `pct` % du total (DONE_RESIDUAL_PCT, envoyé par le serveur).
-->
<template>
  <div v-if="v && v.gap !== null && v.gap !== undefined">
    <b :class="{ 'hv2-text-danger': bad }">{{ gap < 0 ? '−' : '' }}{{ m3(Math.abs(gap)) }}</b>
    <div class="hv2-cell-line">{{ first }} − {{ m3(v.out) }} − {{ m3(v.stock) }}</div>
  </div>
  <span v-else class="hv2-muted">{{ DASH }}</span>
</template>

<script>
import fmt from '../format'

const MIN_M3 = 0.05

export default {
  name: 'HvGapCell',
  props: {
    p: { type: Object, default: null },
    pct: { type: Number, default: 2 }
  },
  computed: {
    DASH: () => fmt.DASH,
    v () { return this.p && this.p.volume },
    // Sous 0,05 m³ l'écart est un arrondi : « 0,0 », jamais « −0,0 ».
    gap () { return Math.abs(this.v.gap) < MIN_M3 ? 0 : this.v.gap },
    bad () { return Math.abs(this.gap) > (Number(this.v.total) * this.pct) / 100 },
    // Avec une correction SUMAL, le premier terme s'écrit en deux :
    // « 474,1 − 109,9 − 364,2 − 0,0 ».
    first () {
      const adj = Number(this.v.adjust) || 0
      return Math.abs(adj) >= MIN_M3
        ? `${fmt.m3(this.v.contract)} ${adj < 0 ? '−' : '+'} ${fmt.m3(Math.abs(adj))}`
        : fmt.m3(this.v.total)
    }
  },
  methods: {
    m3: fmt.m3
  }
}
</script>
